
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* PC用背景画像 */}
      <div
        className="absolute inset-0 bg-cover bg-center hidden sm:block"
        style={{
          backgroundImage: `url(https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/8bc01df165b31c9454e9a51f93b8adaf.webp)`,
        }}
      ></div>
      {/* スマホ用背景画像 */}
      <div
        className="absolute inset-0 bg-cover bg-center block sm:hidden"
        style={{
          backgroundImage: `url(https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/31310f3f336ebc02c0b22a830176f2ad.webp)`,
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-4 lg:px-5 w-full flex justify-end mt-20 sm:mt-0">
        <div className="text-right max-w-xl lg:max-w-2xl mt-20 sm:mt-0">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white mb-4 sm:mb-6 leading-tight drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
            0.01mmの精度で、<br className="hidden sm:block" />
            あなたの"困った"を解決します
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-8 sm:mb-10 lg:mb-12 leading-relaxed drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">
            岡山市から全国へ。創業50年の技術力で<br />特注ネジ・難削材加工に対応
          </p>

          <div className="flex flex-col sm:flex-row items-end sm:items-center justify-end gap-4 sm:gap-6">
            <Link
              to="/contact"
              className="w-auto bg-navy text-white px-8 sm:px-12 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold hover:bg-navy-light transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              お問い合わせフォーム
            </Link>
            <a
              href="tel:086-012-3456"
              className="w-auto bg-white text-navy px-8 sm:px-12 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold border-2 border-navy hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              086-012-3456
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
